<section class="team-section">
  <div class="container">
    <h1 class="team-title">Nuestro Equipo</h1>

    <div class="team-grid">
      @for (item of teamMembers; track $index) {
      <div class="team-item">
        <div class="team-image-wrapper">
          <img class="team-image" [src]="item.image" [alt]="item.name" />
          <div class="team-overlay">
            <div class="team-overlay-content">
              <p class="team-description">{{ item.description }}</p>
            </div>
          </div>
        </div>
        <div class="team-info">
          <h3 class="team-name">{{ item.name }}</h3>
          <p class="team-position">{{ item.position1 }}</p>
          <p class="team-position">{{ item.position2 }}</p>
        </div>
      </div>
      }
    </div>
  </div>
</section>